import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
import dayjs from "dayjs";
import { usePassProgress } from "../hooks/usePassProgress";
import PendingTooltipButton from "./PendingTooltipButton";
const PassProgressBar = (param)=>{
    let { startDate , endDate , remainDay , isPending , pendingDescription , onPendingTooltipOpenChange  } = param;
    const elapsedPercent = usePassProgress(startDate, endDate);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "h-2 w-full overflow-hidden rounded-full bg-gray-50",
                children: !isPending && /*#__PURE__*/ _jsx("div", {
                    className: "h-full rounded-full bg-blue-400",
                    style: {
                        width: "".concat(elapsedPercent, "%")
                    }
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between",
                children: [
                    isPending ? /*#__PURE__*/ _jsx(PendingTooltipButton, {
                        description: pendingDescription,
                        onOpenChange: onPendingTooltipOpenChange
                    }) : /*#__PURE__*/ _jsxs(Typography, {
                        variant: "subtitle2",
                        className: "text-secondary-main",
                        children: [
                            remainDay,
                            "일 남음"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "body2",
                        className: "text-secondary",
                        children: [
                            dayjs(startDate).format("YY.MM.DD"),
                            " ~ ",
                            dayjs(endDate).format("YY.MM.DD"),
                            "까지"
                        ]
                    })
                ]
            })
        ]
    });
};
export default PassProgressBar;
